// Outils de l'espace Community Manager : dates à l'heure du Cameroun, libellés.
import api from "../../services/api";

export const FUSEAU = "Africa/Douala";
export const MULTIPART = { headers: { "Content-Type": "multipart/form-data" } };

export const CANAUX = [
  ["facebook", "Facebook"], ["instagram", "Instagram"], ["youtube", "YouTube"], ["tiktok", "TikTok"],
  ["whatsapp", "WhatsApp"], ["site", "Site Quick Learning"], ["autre", "Autre"],
];
export const FORMATS = [
  ["visuel", "Visuel"], ["carrousel", "Carrousel"], ["video", "Vidéo"], ["story", "Story"],
  ["tutoriel", "Tutoriel"], ["texte", "Texte"],
];
export const STATUTS_CONTENU = [["brouillon", "Brouillon"], ["a_valider", "À valider"], ["valide", "Validé"], ["publie", "Publié"]];
export const TON_CONTENU = { brouillon: "grey", a_valider: "amber", valide: "green", publie: "" };
export const SOURCES = [
  ["formulaire", "Formulaire du site"], ["plateforme", "Plateforme"], ["facebook", "Facebook"], ["instagram", "Instagram"],
  ["whatsapp", "WhatsApp"], ["youtube", "YouTube"], ["tiktok", "TikTok"], ["telephone", "Téléphone"], ["autre", "Autre"],
];
export const STATUTS_DEMANDE = [["nouvelle", "Nouvelle"], ["en_cours", "En cours"], ["transmise", "Transmise au support"], ["cloturee", "Clôturée"]];
export const TON_DEMANDE = { nouvelle: "violet", en_cours: "", transmise: "amber", cloturee: "green" };

export const erreurApi = (err, defaut = "Une erreur est survenue.") => err?.response?.data?.detail || defaut;

// « 2026-10-24 » du jour donné, à l'heure du Cameroun (quel que soit le fuseau de l'appareil).
const formatJour = new Intl.DateTimeFormat("en-CA", { timeZone: FUSEAU, year: "numeric", month: "2-digit", day: "2-digit" });
export const jourCameroun = (moment = new Date()) => formatJour.format(typeof moment === "string" ? new Date(moment) : moment);

export const heureCameroun = (iso) =>
  iso ? new Date(iso).toLocaleTimeString("fr-FR", { timeZone: FUSEAU, hour: "2-digit", minute: "2-digit" }).replace(":", " h ") : "";

export const dateHeure = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { timeZone: FUSEAU, weekday: "short", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" }) : "—";

// Valeur d'un <input type="datetime-local"> à l'heure du Cameroun.
export function versChampDateHeure(iso) {
  if (!iso) return "";
  const parties = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: FUSEAU, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(new Date(iso)).map((p) => [p.type, p.value]));
  return `${parties.year}-${parties.month}-${parties.day}T${parties.hour}:${parties.minute}`;
}

// Arithmétique sur des jours « AAAA-MM-JJ » sans dépendre du fuseau de l'appareil.
export function ajouterJours(jour, n) {
  const d = new Date(`${jour}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
export function lundiDe(jour) {
  const d = new Date(`${jour}T12:00:00Z`);
  return ajouterJours(jour, -((d.getUTCDay() + 6) % 7));
}
const JOURS = ["DIMANCHE", "LUNDI", "MARDI", "MERCREDI", "JEUDI", "VENDREDI", "SAMEDI"];
const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
export const nomJour = (jour) => JOURS[new Date(`${jour}T12:00:00Z`).getUTCDay()];
export const numeroJour = (jour) => Number(jour.slice(8, 10));
export function libelleSemaine(lundi) {
  const dimanche = ajouterJours(lundi, 6);
  const [a1, m1, j1] = lundi.split("-").map(Number);
  const [a2, m2, j2] = dimanche.split("-").map(Number);
  if (m1 === m2) return `${j1}–${j2} ${MOIS[m1 - 1]} ${a2}`;
  return `${j1} ${MOIS[m1 - 1]}${a1 !== a2 ? ` ${a1}` : ""} – ${j2} ${MOIS[m2 - 1]} ${a2}`;
}
export const libelleMois = (yyyymm) => {
  const [a, m] = yyyymm.split("-").map(Number);
  return `${MOIS[m - 1]} ${a}`;
};
const MOIS_COURTS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
export const jourCourt = (jour) => {
  const [, m, j] = jour.split("-").map(Number);
  return `${j} ${MOIS_COURTS[m - 1]}`;
};

export const nombre = (n) => (n === null || n === undefined ? "—" : new Intl.NumberFormat("fr-FR").format(n));
export const pourcent = (n) => (n === null || n === undefined ? "Non calculable" : `${Number(n).toFixed(1).replace(".", ",")} %`);

export function ouvrirPage(page) {
  window.dispatchEvent(new CustomEvent("ql-open-page", { detail: page }));
}

export function formulaire(valeurs) {
  const fd = new FormData();
  Object.entries(valeurs).forEach(([cle, valeur]) => {
    if (valeur !== undefined && valeur !== null) fd.append(cle, valeur);
  });
  return fd;
}

export const chargerContenus = (params = "") => api.get(`cm/contenus/${params}`).then((r) => r.data.contenus || []);
